import React, { useCallback, useContext, useEffect } from 'react';
import UPPage from '../components/UPPage';
import useService from '../hooks/useService';
import { RouteComponentProps } from 'react-router';
import token from '../lib/services/token';
import { PasswordSetupForm } from '../components/PasswordSetupForm';
import { useTranslation } from 'react-i18next';
import { GlobalErrorContext } from '../context';
import { redirect } from '../lib/Utils';
import { LinearProgress, Typography } from '@mui/material';
import useProxyAuth from '../hooks/useProxyAuth';
import { ErrorCodes } from '../types';

/**
 * Password setup page
 */
export const PasswordSetup = (
  props: RouteComponentProps<{ webToken: string }>
) => {
  useProxyAuth();

  const { webToken } = props.match.params;
  const { isRequestDone, success, send, response } = useService(
    useCallback(() => token(webToken), [webToken])
  );

  useEffect(() => {
    send();
  }, [send]);

  const { t } = useTranslation('translation');
  const { setGlobalError } = useContext(GlobalErrorContext);

  if (!isRequestDone) {
    return <LinearProgress color="primary" />;
  }

  if (
    response &&
    response.error &&
    response.error.code === ErrorCodes.SERVER_ERROR
  ) {
    return (
      <UPPage>
        <Typography variant="body1">{t('serverError')}</Typography>
      </UPPage>
    );
  }

  if (
    response &&
    response.error &&
    response.error.code === ErrorCodes.NOT_FOUND
  ) {
    return (
      <UPPage>
        <Typography variant="body1">{t('tokenNotFoundError')}</Typography>
      </UPPage>
    );
  }

  if (success && response && response.body && response.body.set) {
    redirect('/auth/');
  }

  return (
    <UPPage>
      <Typography component="h1" variant="h5" align="center">
        {t('passwordSetupHeader')}
      </Typography>
      <PasswordSetupForm
        token={webToken}
        handleSuccess={() => redirect('/auth/')}
        handleFailure={() => setGlobalError(t('setupPasswordError'))}
      />
    </UPPage>
  );
};
